export default __webpack_public_path__ + "static/media/m-400.b71748ae.woff2";